
import { alertsApi , customerFileApi , notificationApi } from "../../../api/apiClient";
/* alert & notification service */


function getAlerts() {
    return alertsApi.get("/alerts/templates")
  }
  
  
  function updateDefault(id)
  {
    return alertsApi.put(`/alerts/templates/${id}/make-default`)
  }
  
  function updateAlert(data)
  {
    return alertsApi.put(`/alerts/templates/${data.id}`, data)
  }
  
  function deleteAlert(id)
  {
  return alertsApi.delete(`/alerts/templates/${id}`)
  }
  
  
  function CreateAlert(data)
  {
  return alertsApi.post("/alerts/templates",data)
  }
  
function uploadCustomerFile(data)
{
  return customerFileApi.post("/batchentry/uploadFile",data)
}

function GroupList(){
  return notificationApi.get("/notifications/groups")
}

function InsertCustomerFile(customerData) {
  return notificationApi.post('/notifications/customers/addBatch',customerData)

}
  
export const alertsNotificationService = {
    getAlerts,
    updateDefault,
    updateAlert,
    deleteAlert,
    CreateAlert,
    uploadCustomerFile,
    InsertCustomerFile,
    GroupList,
  };